import { getOptionsStatus } from './dataStatus'

export default () => ({
  optionsStatus: [{id: null, label: 'Todos'}, ...getOptionsStatus()],
  entities: 'schedules',
  includes: ['agenda.professional', 'patient.degree', 'transfer'],
  schedules: [],
  currentSchedule: {},
  schedulesSelected: [],
  search: {
    agenda_id: null,
    convent_id: null,
    patient_type: null,
    patient_id: null,
    rule_id: null,
    speciality_id: null,
    transfer_id: null,
    date_start: null,
    date_end: null,
    price: null,
    status: '',
    time: null
  },
  all: false,

  searchActive: false,

  scheduleIds: [],

  showModalCancel: false,
  showModalTransfer: false,
  showModalReverser: false
})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/resources/data.js